export default __webpack_public_path__ + "static/media/metamask.c09c031b.png";